import { useGetIcpProductCategoriesQuery } from '@vizit/api';
import * as React from 'react';

interface UseGetICPProductCategoriesResult {
  icpProductCategoriesMap: Record<string, string> | undefined;
  isLoading: boolean;
}

function useGetICPProductCategories(): UseGetICPProductCategoriesResult {
  const { data: icpProductCategories, isLoading } = useGetIcpProductCategoriesQuery({
    limit: 100,
    offset: 0,
    sort_by: 'category_name',
    sort_direction: 'asc',
  });

  const icpProductCategoriesMap = React.useMemo(() => {
    return icpProductCategories?.reduce(
      (acc, category) => {
        acc[category.id] = category.category_name;
        return acc;
      },
      {} as Record<string, string>,
    );
  }, [icpProductCategories]);

  return { icpProductCategoriesMap, isLoading };
}

export { useGetICPProductCategories };
export type { UseGetICPProductCategoriesResult };
